<script>
  import { alert } from 'vue-strap';
  
  export default {
    components: { alert },
    props: {
      despesas: {
        type: Array,
        required: true,
      },
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    methods: {
      deletarItem(indice) {
        this.despesas.splice(indice, 1);
      },
    },
    computed: {
      
    }
  }
</script>

<template>
  <div>
    <alert type="warning" v-if="despesas.length === 0">
      <i class="fa fa-warning"></i> Nenhuma despesa adicionada.
    </alert>
    
    <div class="bs-callout bs-callout-info no-margin-top" v-for="(despesa, index) in despesas">

      <h4>
        Item #{{ index + 1 }}

        <button
          type="button"
          class="btn btn-sm btn-danger btn-delete-item"
          title="Excluir item"
          @click="deletarItem(index)"
          v-if="!relatorio">
          <i class="fa fa-trash"></i>
        </button>
      </h4>
      
      <div class="row">
        <dl class="col-md-4">
          <dt>Rubrica</dt>
          <dd>{{ despesa.rubrica.nome }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Subrubrica</dt>
          <dd>{{ despesa.subrubrica.nome }}</dd>
        </dl>
        <dl class="col-md-4">
          <dt>Valor</dt>
          <dd>{{ despesa.valorSolicitado }}</dd>
        </dl>
      </div>

      <div class="row" v-if="despesa.observacao">
        <dl class="col-md-12">
          <dt>Observação</dt>
          <dd>{{ despesa.observacao }}</dd>
        </dl>
      </div>
      
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/compartilhado/FormListaDespesasRubricas.vue